import "../styles/FAQSection.css";
import TextField from "@mui/material/TextField/TextField";
import Paper from "@mui/material/Paper/Paper";
import { useEffect, useState } from "react";
import { Accordion } from "../components/Certification/Accordion";
import { AccordionSummary } from "../components/Certification/AccordionSummary";
import { AppToolbar } from "../components/AppToolbar";
import { FAQAccordionDetails } from "../components/FAQSection/FAQAccordionDetails";
import { SpinnerWrapper } from "../components/SpinnerWrapper";
import { useLocation } from "react-router-dom";
import { Routes } from "../types/Routes";
import useUpdateUrl from "../hooks/useUpdateUrl";
import { useFAQSection } from "../hooks/useFAQSection";
import { Token } from "../theme";
import { ROWS_PER_PAGE } from "../App";

export default function FAQSection() {
  const [searchQuestion, setSearchQuestion] = useState<string>("");
  const [expanded, setExpanded] = useState<string | false>("");
  const { questions, isLoading } = useFAQSection(searchQuestion, ROWS_PER_PAGE);
  const searchParams = new URLSearchParams(useLocation().search);
  const title = searchParams.get("title");
  const { updateUrl } = useUpdateUrl(Routes.FAQS, searchParams);

  useEffect(() => {
    if (title !== null && title !== "") {
      setSearchQuestion(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <AppToolbar title="FAQ Section">
        <TextField
          label="Search by title"
          value={searchQuestion}
          onChange={(e) => {
            setSearchQuestion(e.target.value);
            searchParams.set("title", e.target.value);
            updateUrl();
          }}
          autoComplete="off"
          fullWidth
          autoFocus
          variant="outlined"
          size="small"
        />
      </AppToolbar>
      <SpinnerWrapper isLoading={isLoading}>
        <Paper>
          {questions.map((quest) => (
            <Accordion
              expanded={expanded === `panel${quest.externalId}`}
              onChange={handleChange(`panel${quest.externalId}`)}
              key={quest.externalId}
              TransitionProps={{ unmountOnExit: true }}
            >
              <AccordionSummary
                title={quest.title}
                sx={{
                  backgroundColor: Token.statusWarningBg,
                  "&:hover": {
                    backgroundColor: Token.actionPrimary,
                  },
                }}
              />
              <FAQAccordionDetails question={quest.description} />
            </Accordion>
          ))}
        </Paper>
      </SpinnerWrapper>
    </>
  );
}
